module.exports = __webpack_public_path__ + "img/speech_9.430a4887.jpeg";